import { LoadingOutlined } from '@ant-design/icons';

import '@/styles/tailwind.css';
import { ConfigProvider, Spin } from 'antd';
import { ComponentType, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import Layout from '@/components/Layout';
import { privateRoutes as privateRoutesArray } from '@/routes/private';
import { publicRoutes as publicRoutesArray } from '@/routes/public';
import { colors } from '@/styles/theme';

import GlobalStyles from '../styles/GlobalStyles';
import ProtectedRoute from './protectedRoute';
import SessionMiddleware from './sessionMiddleware';

import '@progress/kendo-theme-default/dist/all.css';
import '@ant-design/v5-patch-for-react-19';

const renderRoutes = (
  routesObject: Record<string, { Component: ComponentType; path: string }>,
  requireAuth: boolean
) => {
  return Object.values(routesObject).map(({ Component, path }) => (
    <Route
      element={
        <ProtectedRoute requireAuth={requireAuth}>
          <Component />
        </ProtectedRoute>
      }
      key={`route-${path}`}
      path={path}
    />
  ));
};

const App = () => {
  return (
    <ConfigProvider theme={{ token: { colorPrimary: colors.primary } }}>
      <GlobalStyles />
      <Suspense
        fallback={
          <div className="flex h-screen w-screen items-center justify-center bg-white">
            <Spin indicator={<LoadingOutlined className="text-[48px]!" />} size="large" />
          </div>
        }
      >
        <SessionMiddleware>
          <Layout>
            <Routes>
              {renderRoutes(privateRoutesArray, true)}
              {renderRoutes(publicRoutesArray, false)}
            </Routes>
          </Layout>
        </SessionMiddleware>
      </Suspense>
    </ConfigProvider>
  );
};

export default App;
